import React from 'react'
import "./congratulations.scss"
import { CongratulationsInfo } from '../../components'

const Congratulations = () => {
  return (
    <div className='congratulations-page'>
      <CongratulationsInfo />
    </div>
  )
}

export default Congratulations